module.exports = __webpack_public_path__ + "img/na-freight-assumptions-screen.7b22b08b.png";